import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
// import { useUserOrder } from '../index';
import { useApiError } from '../useApiError';
import { useUserShouHouList } from '../useUserShouHou/list';
import { useUserShouHouOrder } from '../useUserShouHou/index';

export const useShouHou = (orderId: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useShouHoucontext---------", context.useApiError);
  // const useOrder = useUserOrder();
  const useAfterSaleList = useUserShouHouList(orderId);
  const useUserShouHouOrderList = useUserShouHouOrder('shouhou');
  // Shared ref holding the response from the API
  const applyResult = sharedRef(null, `useShouHou-${orderId}`);
  // 售后结果
  const afterResult = sharedRef(null, `useShouHou-${orderId}`);
  // 退款结果
  const refund = sharedRef(null, `useShouHou-${orderId}`);
  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useShouHou-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useShouHou-error-${orderId}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const apply = async (params: CustomQuery) => {
    try {
      loading.value = true;
      // console.log('context.$xbuy', context);
      const res = await context.$xbuy.api.orderApply(params);
      await useUserShouHouOrderList.shouhouOrderGet({ status: 'ORDER_AFTER_SALE', page_no: 1, page_size: 10});
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        // await useOrder.search({});
        // await useAfterSaleList.shouhouGet({ order_id: orderId });
        setError(res);
        applyResult.value = res.data;
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  const orderRefund = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.orderRefund(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        await useAfterSaleList.shouhouGet({ order_id: orderId });
        refund.value = res;
        error.value = null;
        setError(res);
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  const orderAfterSales = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.orderSalesorder(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        afterResult.value = res.data;
        error.value = null;
        await useAfterSaleList.shouhouGet({ order_id: orderId });
        setError(res);
        // await orderRefund({ after_sale_id: afterResult.value?.after_sale_id });
      } else {
        setError(res);
        afterResult.value = null;
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    apply,
    aftersales: orderAfterSales,
    refund: orderRefund,
    refundRes: computed(() => refund.value),
    afterRes: computed(() => afterResult.value),
    applyRes: computed(() => applyResult.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
